/* eslint-disable no-shadow */
// axios
import { http } from "@/api/index";

// Locales
import i18n from "@/i18n";

// Actions
import {
	GetWindRoseChartData,
	GetWindRoseChartDataError,
	GetWindRoseChartDataSuccess,
} from "@/stores/actions/WindRose";

// Utils
import { WindRoseChartLightColors } from "@/constants/themes-colors/WindRoseColors";
import FetchStatus from "@/constants/fetch-status/FetchStatus";

const defaultTraces = [
	{
		r:      [],
		theta:  [],
		type:   "",
		name:   "",
		marker: "",
	},
	{
		r:      [],
		theta:  [],
		type:   "",
		name:   "",
		marker: "",
	},
	{
		r:      [],
		theta:  [],
		type:   "",
		name:   "",
		marker: "",
	},
	{
		r:      [],
		theta:  [],
		type:   "",
		name:   "",
		marker: "",
	},
	{
		r:      [],
		theta:  [],
		type:   "",
		name:   "",
		marker: "",
	},
	{
		r:      [],
		theta:  [],
		type:   "",
		name:   "",
		marker: "",
	},
];

const ROSE_DIRECTIONS = [
	"N", "NNE", "NE", "ENE", "E", "ESE", "SE", "SSE", "S", "SSW", "SW", "WSW", "W", "WNW", "NW", "NNW",
];

const state = {
	status:         FetchStatus.Init,
	successMessage: "",
	errorMessage:   "",
	errorHeade:     "",
	data:           {},
	traces:         [],
	tooltipText:    i18n.t("Tooltips.WindRose"),
};

const actions = {

	[GetWindRoseChartData]: ({ commit }, monitoringElementId) =>
	{
		commit(GetWindRoseChartData);
		http.get(`/WindRose/${monitoringElementId}`)
			.then((resp) =>
			{
				const traces = defaultTraces;
				const { data } = resp;
				for (let i = 0; i < data.length; i++)
				{
					for (let j = 0; j < data[i].segments.length; j++)
					{
						switch (data[i].segments[j].speedRange)
						{
						case (0):
							traces[5].r.push(data[i].segments[j].percentageRadius);
							traces[5].theta = ROSE_DIRECTIONS;
							traces[5].type = "barpolar";
							traces[5].name = "< 3 m/s";
							traces[5].marker = { color: WindRoseChartLightColors.firstLevel };
							break;
						case (1):
							traces[4].r.push(data[i].segments[j].percentageRadius);
							traces[4].theta = ROSE_DIRECTIONS;
							traces[4].type = "barpolar";
							traces[4].name = "3 - 5 m/s";
							traces[4].marker = { color: WindRoseChartLightColors.secondLevel };
							break;
						case (2):
							traces[3].r.push(data[i].segments[j].percentageRadius);
							traces[3].theta = ROSE_DIRECTIONS;
							traces[3].type = "barpolar";
							traces[3].name = "5 - 7 m/s";
							traces[3].marker = { color: WindRoseChartLightColors.thirdLevel };
							break;
						case (3):
							traces[2].r.push(data[i].segments[j].percentageRadius);
							traces[2].theta = ROSE_DIRECTIONS;
							traces[2].type = "barpolar";
							traces[2].name = "7 - 9 m/s";
							traces[2].marker = { color: WindRoseChartLightColors.fourthLevel };
							break;
						case (4):
							traces[1].r.push(data[i].segments[j].percentageRadius);
							traces[1].theta = ROSE_DIRECTIONS;
							traces[1].type = "barpolar";
							traces[1].name = "9 - 11 m/s";
							traces[1].marker = { color: WindRoseChartLightColors.fifthLevel };
							break;
						case (5):
							traces[0].r.push(data[i].segments[j].percentageRadius);
							traces[0].theta = ROSE_DIRECTIONS;
							traces[0].type = "barpolar";
							traces[0].name = "> 11 m/s";
							traces[0].marker = { color: WindRoseChartLightColors.sixthLevel };
							break;
						default:
							break;
						}
					}
				}
				commit(GetWindRoseChartDataSuccess, traces);
			})
			.catch((error) =>
			{
				commit(GetWindRoseChartDataError, error);
			});
	},

};
const mutations = {
	[GetWindRoseChartData]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[GetWindRoseChartDataSuccess]: (state, data) =>
	{
		state.data = data;
		state.status = FetchStatus.Loaded;
	},
	[GetWindRoseChartDataError]: (state, error) =>
	{
		const missingDataError = i18n.t("ErrorMessages.UnavailableData");
		const missingDataMessage = i18n.t("ErrorMessages.UnavailableWindData");
		const badDataError = i18n.t("ErrorMessages.UnavailableData");
		const badDataMessage =  i18n.t("ErrorMessages.UnavailableWindData");

		state.errorMessage = (error.status === 400 ? missingDataMessage : badDataMessage);
		state.errorHead = (error.status === 400 ? missingDataError : badDataError);
		state.error = error.response;
		state.status = FetchStatus.Error;
	},
};

export default {
	state,
	actions,
	mutations,
};
